import { createEvent } from 'effector';

export const openModalEv = createEvent();

export const closeModalEv = createEvent();
